export const LOCAL_STORAGE_KEY_MAP = {
  token: 'token',
  applicantsPageSize: 'applicantsPageSize',
  casesPageSize: 'casesPageSize',
} as const
